import React, { useState, useEffect, useContext } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { PageContext } from './PageContext';
import { atolUser } from '../services/interfaces';
import { UserContext } from './UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faAddressCard, faInfoCircle, faQuestionCircle, faRobot, faMagicWandSparkles} from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import parse from 'html-react-parser';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent, MultiSelect } from '@progress/kendo-react-dropdowns';
import { DateTimePicker, DateTimePickerChangeEvent,  } from '@progress/kendo-react-dateinputs';
import {Grid, GridColumn as Column, GridCellProps, GridToolbar, getSelectedState, GridSelectionChangeEvent, GridHeaderCellProps} from '@progress/kendo-react-grid';
import {SelectDescriptor} from '@progress/kendo-react-data-tools'
import { mailMessage } from '../services/interfaces';
import { getAdsForBulkEmail } from '../services/apiService';
import { getter } from '@progress/kendo-react-common';
import { getAdContacts, sendMailMessage, getAIMessageBody } from '../services/apiService';
import type { ListItemProps, MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
interface EmailFormProps{
    onClose:()=>void,
    emailType:string,
    selectedContact: atolUser[],
    helpMe:boolean,
    readonly:boolean
}


 interface bulkAd{
    element:string;
    slug:string;
    size:string;
    customer:string;
    tmpChar2:string;
    firstRun:string;
    category:string;
    pubDate:number;
    status:string;
    comment:string;
    comment2:string
}

interface aiMessage{
    type:string;
    messageID:string;
    message:string;
}


export const EmailForm=(props:EmailFormProps)=>{
    const pageContext=useContext(PageContext);
    const userContext=useContext(UserContext);
    const [mailMessage,setMailMessage]=useState<mailMessage>({
            element:pageContext?.selectedAd.element||"",
            proofType:pageContext?.selectedAd.tmpInt2||0,
            emailBody:"",
            sendTime:new Date(),
            appUser:userContext?.user.username||"",
            operation:"",
            status:"SENDIT",
            recipient:"",
            user:"",
            key:"",
            includeAds:""
        });
    const [adsForBulk, setAdsForBulk]=useState<Array<bulkAd>>([]);
    const [selectedContact, setSelectedContact]=useState([{}]);
    const [showContactList, setShowContactList]=useState(false);
    const [contacts, setContacts] = useState<Array<atolUser>>([]);
    const [recipientValid, setRecipientValid]=useState(false);
    const [sendFailWarning, setSendFailWarning]=useState(false);
    const [emailTypeSelector, setEmailTypeSelector]=useState({text:"", value:""})
    const [readOnlyRecipient, setReadOnlyRecipient]=useState("");
    const emailTypeChange=(e:DropDownListChangeEvent)=>{
        setEmailType(e.value);
    }

    const viewContactList=()=>{
        setShowContactList(true);
    }

    const hideContactList=()=>{
        setShowContactList(false);
    }

    const showSendFailWarning=()=>{
        setSendFailWarning(true);
    }

    const hideSendFailWarning=()=>{
        setSendFailWarning(false);
    }

    
    const emailValidator = (email:string) => {
        const value = email;
        const emailRegex = new RegExp(/\S+@\S+\.\S+/)
        if (emailRegex.test(value)) {
            setRecipientValid(true);
        }
    }
    
    
    const readOnlyRecipientChange=(e: InputChangeEvent)=>{
        setReadOnlyRecipient(e.value);
        emailValidator(e.value);
    }
    


    const recipientChanged=(e:MultiSelectChangeEvent)=>{
        console.log(e.value);
        setSelectedContact(e.value);
        if (e.value.length>0){
            setRecipientValid(true);
            hideSendFailWarning();
        }else{
            setRecipientValid(false);
        }
    }

    const setEmailType=(type:{text:string, value:string})=>{
        console.log(type);
        //Get ads for this customer.
        var account = pageContext?.selectedAd.fileSize2||"";
        var element = pageContext?.selectedAd.element||"";
        var status="";
        if(type.value=="990"){
            status = pageContext?.dashStat.Dash1Status||"";        
        }
        if(type.value=="995"){
            status = pageContext?.atolStatuses.ProofStatuses||"";        
        }
        setEmailTypeSelector(type);
        getAdsForBulkEmail(element,account,status).then(data=>{
            setAdsForBulk(data);
        });
        setMailMessage({...mailMessage,operation:type.value});
    }
    
    const setAIMessageBody=()=>{
        var type:string ="";
        if (props.emailType!=""){
            switch (props.emailType){
                case "995":
                    type="Proof";
                    break;
                case "990":
                    type="Submit";
                    break;
            }
        }else{
            if (mailMessage.operation!=""){
                switch (mailMessage.operation){
                case "995":
                    type="Proof"
                    break;
                case "990":
                    type="Submit"
                    break;
                }
            }
        }
        
        getAIMessageBody(type).then(data=>{
            var aiMessage:aiMessage = data;
            if (aiMessage.message!=null){
                setMailMessage({ ...mailMessage, emailBody: aiMessage.message });
            }
        });
    }

    const setMessageBody = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setMailMessage({ ...mailMessage, emailBody: e.target.value });
    };

    const setSendTime=(e:DateTimePickerChangeEvent)=>{
        console.log(e.value);
        if (e.value){
            setMailMessage({...mailMessage,sendTime:e.value});
        }
    }

    const [bulkSelectedState, setBulkSelectedState] = useState<SelectDescriptor>({});
    
    const bulkIdGetter = getter("element");

    const onBulkSelectionChange = (event: GridSelectionChangeEvent) => {

        const newBulkSelectedState = getSelectedState({
            event,
            selectedState: bulkSelectedState,
            dataItemKey: "element"
        });
        setBulkSelectedState(newBulkSelectedState);
    };

    const EmptyCell = (props:GridHeaderCellProps) => {
        return <span />;
    };


    const sendEmail= ()=>{
        var includeAds:string="";
        console.log(bulkSelectedState);
        if (Object.keys(bulkSelectedState).length>0){
            var selectedEls = Object.keys(bulkSelectedState);
            var selectedAds: bulkAd[] = []
            adsForBulk.map((item) => {
                if (selectedEls.includes(item.element)){
                    selectedAds.push(item);
                }                
            })
            console.log(selectedAds);
            includeAds=JSON.stringify(selectedAds);
        }

        if (recipientValid){
            if (props.readonly){
                //Send a read-only email to the specified address.
                    var newMail:mailMessage={
                        element:mailMessage.element,
                        proofType:mailMessage.proofType,
                        emailBody:mailMessage.emailBody,
                        sendTime:mailMessage.sendTime,
                        appUser:mailMessage.appUser,
                        operation:"997",
                        status:"DEFAULT",
                        recipient:readOnlyRecipient,
                        user:userContext?.user.username||"",
                        key:userContext?.user.apiKey||"",
                        includeAds:includeAds
                    }
                    console.log(newMail);
                    sendMailMessage(newMail).then(resp=>{
                        console.log(resp);
                        if (resp=="200"){
                            props.onClose();
                        }
                    });
            }else{
                //send a normal email to the selected recipient
                selectedContact.forEach(item=>{
                    var newMail:mailMessage={
                        element:mailMessage.element,
                        proofType:mailMessage.proofType,
                        emailBody:mailMessage.emailBody,
                        sendTime:mailMessage.sendTime,
                        appUser:mailMessage.appUser,
                        operation:mailMessage.operation,
                        status:mailMessage.status,
                        recipient:(item as atolUser).email,
                        user:(item as atolUser).userName,
                        key:(item as atolUser).apiKey,
                        includeAds:includeAds
                    }
                    console.log(newMail);
                    sendMailMessage(newMail).then(resp=>{
                        console.log(resp);
                        if (resp=="200"){
                            props.onClose();
                        }
                    });
                }); 
            }
        }else{
            showSendFailWarning();
        }
    }
    const getContacts=()=>{
        const element = pageContext?.selectedAd.element;
        if (element){
            getAdContacts(element).then(data=>{
                console.log(data);
                setContacts(data);
            });
        }
    }


    const MyCustomItem = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const { dataItem } = itemProps;
        var userType="";
        switch (dataItem.security){
            case 0:
                userType="Customer";
                break;
            case 1:
                userType="Sales Rep";
                break;
            case 2:
                userType="Sales Assist";
                break;
            case 3:
                userType="Agency"
                break;
        }
        return React.cloneElement(
            li,
            li.props,
            <>
                {dataItem.fullName} ({userType} - {dataItem.email})
            </>
        );
    };

    useEffect(()=>{
        console.log(props.emailType);
        console.log(props.selectedContact);
        if (props.emailType!=""){
            switch (props.emailType){
                case "995":
                    setEmailType({ text: "Send Proof", value: "995" });
                    break;
                case "990":
                    setEmailType({ text: "Send Materials Request", value: "990" });
                    break;
            }
        }
        if (props.readonly){
            setEmailType({ text: "Send Proof", value: "995" });
        }
        if (props.selectedContact.length<1){
            getContacts();
            viewContactList();
        }else{
            setSelectedContact(props.selectedContact);
            setRecipientValid(true);
        }
        if (props.helpMe==true){
            setAIMessageBody();
        }
    },[])

    useEffect(()=>{
        console.log(emailTypeSelector);
    },[emailTypeSelector])

    return(
        <Dialog title={props.readonly?"Send Read-Only Email":"Send to Contact"} onClose={props.onClose} width={"50%"} height={"85vh"}>
            {sendFailWarning&& <Notification type={{style:"error", icon:true}} onClose={hideSendFailWarning}><span>You must select a recipient first.</span></Notification>}
            <div className="rounded bg-primary text-white p-3 mb-3">
                <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder==="SendToContact")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder==="SendToContact")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
            </div>
            <div className='formField'>
                <DropDownList id="sfEndDay" 
                    data={[
                        { text: "Send Proof", value: "995" },
                        { text: "Send Materials Request", value: "990" },
                    ]}
                    textField='text' 
                    dataItemKey='value' 
                    fillMode={"outline"} 
                    defaultItem={ { text: "Send Proof", value: "0" }}
                    onChange={emailTypeChange}
                    value={emailTypeSelector}
                    disabled={props.readonly}
                />
            </div>
            {showContactList&&props.readonly==false&& 
            <div className='formField'>
                <MultiSelect 
                    placeholder="Select recipients" 
                    data={contacts} 
                    dataItemKey='userName' 
                    textField='fullName' 
                    fillMode={"outline"}
                    itemRender={MyCustomItem}
                    onChange={recipientChanged}
                    valid={recipientValid}
                    
                ></MultiSelect>
            </div>
            }
            {props.readonly==true&&
            <div className='formField'>
                <Input onChange={readOnlyRecipientChange} valid={recipientValid}></Input>
            </div>
            }
            <div className='formField'>
                    <DateTimePicker value={mailMessage.sendTime} format={pageContext?.glSettings.Locale=="en-GB"?"dd-MM-yyyy hh:mm":"MM/dd/yyyy hh:mm"} onChange={setSendTime} ></DateTimePicker>
            </div>
            <div className='formField'>
                <div className='mb-3'>Message:&nbsp;<Button fillMode={"outline"} onClick={setAIMessageBody} size={"small"}><FontAwesomeIcon icon={faMagicWandSparkles}></FontAwesomeIcon> Help Me</Button></div>
                <textarea className="form-control" maxLength={3000} rows={10} id="scMessage" onChange={setMessageBody} value={mailMessage.emailBody}></textarea>
            </div>
            {emailTypeSelector.value=="995"?
            <div>
                <p>Include other ads for this advertiser:</p>
                <Grid
                    data={adsForBulk}
                    pageSize={adsForBulk.length}
                    dataItemKey='element'
                    selectable={{enabled: true, mode:"multiple"}}
                    onSelectionChange={onBulkSelectionChange}
                    defaultSelect={{}}
                >
                    <Column
                        columnType='checkbox'
                        title="&nbsp;"
                        width="40px"
                        cells={{headerCell:EmptyCell}}
                    />
                    <Column
                        field='element'
                        title='Ad Number'
                    />
                    <Column
                        field='size'
                        title='Size'
                    />
                    <Column
                        field='comment2'
                        title='Tagline'
                    />
                </Grid>
            </div>:null}   
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={sendEmail}>Send</Button>
            </DialogActionsBar>
        </Dialog>
    )
}